// The one word on a newer release (lib/app-release.ts): it is ready, and Reload loads it.
// Non-blocking, like MaintenanceBanner: it sits above the screen and blocks nothing, and it never
// opens a dialog (no `window.confirm`).
//
// Reload is one click only where SAM would reload by itself (a view page, nothing typed, no
// drawer open, nothing in flight). Anywhere else it warns first and needs a second, in-page
// click, because a reload discards whatever the page holds unsaved (2026-10-21). × hides it for
// this release in this tab; the next page change still lands on the new release.

import { useState } from 'react';
import {
  dismissReleaseBanner,
  releaseShortLabel,
  reloadForRelease,
  reloadIsSafe,
  useReleaseState,
} from '@/lib/app-release';

export function UpdateBanner() {
  const release = useReleaseState();
  // The release the operator was asked about: a newer one asks again from the first click.
  const [askedFor, setAskedFor] = useState<string | null>(null);
  const update = release.confirmed;
  if (!update || release.dismissed === update.sha) return null;
  // Read at render from live state; `useReleaseState` re-renders on a page change, an edit and
  // a hold, and the click below asks again in case anything moved since.
  const safe = reloadIsSafe();
  const asking = askedFor === update.sha;
  const onReload = () => {
    if (asking || reloadIsSafe()) {
      reloadForRelease();
      return;
    }
    setAskedFor(update.sha);
  };
  return (
    <div className="drawer-notice update-banner" role="status" aria-live="polite">
      <span className="drawer-notice-ico" aria-hidden="true">
        ↻
      </span>
      <span className="update-banner-text">
        A new version of SMART is ready ({releaseShortLabel(update)}).
        {release.chunkFailed && ' This part of SMART changed: reload to use it.'}
        {(asking || !safe) && ' Save your work first: reloading discards unsaved changes.'}
      </span>
      <span className="update-banner-actions">
        <button type="button" className="btn btn-sm btn-primary" onClick={onReload}>
          {asking ? 'Reload anyway' : 'Reload'}
        </button>
        <button
          type="button"
          className="btn btn-sm btn-ghost"
          aria-label="Dismiss the update notice"
          onClick={() => dismissReleaseBanner(update.sha)}
        >
          ×
        </button>
      </span>
    </div>
  );
}
